import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import styled from '@emotion/styled';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { Search } from 'lucide-react';
import { ArrowLeft } from 'lucide-react';
import { Bot } from 'lucide-react';
import { Users } from 'lucide-react';
import { MessageCircle } from 'lucide-react';
import { Avatar, Chip } from '@heroui/react';
import { Button } from '@edusense/shared-ui-kit';
import { searchUsers as searchUsersHandler } from '../../handlers/DM';
import { CHAT_TEST_IDS } from '@edusense/shared-constants';
const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--theme-paper, #ffffff);
  
  .dark & {
    background-color: var(--theme-paper, #1f2937);
  }
`;
const Header = styled.header`
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--theme-border, #e5e7eb);
  background-color: var(--theme-paper, #ffffff);
  flex-shrink: 0;
  
  .dark & {
    background-color: var(--theme-paper, #1f2937);
    border-color: var(--theme-border, #374151);
  }
`;
const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const Title = styled.h1`
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
  color: var(--theme-text, #111827);
  display: flex;
  align-items: center;
  gap: 0.5rem;

  .dark & {
    color: var(--theme-text, #f3f4f6);
  }
`;
const SwitchButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid var(--theme-border, #e5e7eb);
  border-radius: 6px;
  background-color: transparent;
  color: var(--theme-text, #111827);
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;

  &:hover {
    background-color: var(--theme-hover, #f3f4f6);
  }

  .dark & {
    color: var(--theme-text, #f3f4f6);
    border-color: var(--theme-border, #374151);
    
    &:hover {
      background-color: var(--theme-hover, #374151);
    }
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;
const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  border-bottom: 1px solid var(--theme-border, #e5e7eb);
  padding-bottom: 0.5rem;
  position: relative;
`;
const SearchInput = styled.input`
  flex: 1;
  border: none;
  background: transparent;
  padding: 0.5rem 0;
  font-size: 1rem;
  color: var(--theme-text, #111827);
  outline: none;

  &::placeholder {
    color: var(--theme-text-secondary, #6b7280);
  }

  .dark & {
    color: var(--theme-text, #f3f4f6);
    
    &::placeholder {
      color: var(--theme-text-secondary, #9ca3af);
    }
  }
`;
const GroupNameInput = styled.input`
  width: 100%;
  border: none;
  background: transparent;
  padding: 0.75rem 0;
  font-size: 1rem;
  color: var(--theme-text, #111827);
  border-bottom: 1px solid var(--theme-border, #e5e7eb);
  margin-top: 1rem;
  outline: none;

  &::placeholder {
    color: var(--theme-text-secondary, #6b7280);
  }

  .dark & {
    color: var(--theme-text, #f3f4f6);
    border-color: var(--theme-border, #374151);
    
    &::placeholder {
      color: var(--theme-text-secondary, #9ca3af);
    }
  }
`;
const SearchResultsContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  margin-top: 1rem;
`;
const UserItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0.75rem 0;
  cursor: pointer;
  border-radius: 0.5rem;
  transition: background-color 0.2s;

  &:hover {
    background-color: var(--theme-paper-hover, #f9fafb);
  }

  .dark &:hover {
    background-color: var(--theme-paper-hover, #374151);
  }
`;
const UserInfo = styled.div`
  margin-left: 0.75rem;
  display: flex;
  flex-direction: column;
  flex: 1;
`;
const UserName = styled.div`
  font-weight: 500;
  color: var(--theme-text, #111827);

  .dark & {
    color: var(--theme-text, #f3f4f6);
  }
`;
const UserUsername = styled.div`
  font-size: 0.875rem;
  color: var(--theme-text-secondary, #6b7280);

  .dark & {
    color: var(--theme-text-secondary, #9ca3af);
  }
`;
const CreateButton = styled.button`
  background-color: ${(props)=>props.disabled ? '#ccc' : 'var(--theme-primary, #10b981)'};
  color: white;
  padding: 0.5rem 1.25rem;
  border: none;
  border-radius: 9999px;
  font-weight: 600;
  cursor: ${(props)=>props.disabled ? 'not-allowed' : 'pointer'};
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &:hover:not(:disabled) {
    background-color: var(--theme-primary-dark, #059669);
  }
`;
const StatusMessage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
  color: ${(props)=>{
    switch(props.type){
        case 'error':
            return 'var(--theme-error, #dc2626)';
        case 'loading':
            return 'var(--theme-text-secondary, #6b7280)';
        default:
            return 'var(--theme-text-secondary, #6b7280)';
    }
}};
  font-size: 0.875rem;
  text-align: center;
`;
const RetryButton = styled.button`
  background-color: var(--theme-primary, #10b981);
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: var(--theme-primary-dark, #059669);
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;
const CreateChatViewEnhanced = ({ onBack, onSwitchToAIChat, onCreateChat, isCreating = false })=>{
    const [searchTerm, setSearchTerm] = useState('');
    const [recipients, setRecipients] = useState([]);
    const [searchResults, setSearchResults] = useState([]);
    const [groupName, setGroupName] = useState('');
    const [isSearching, setIsSearching] = useState(false);
    const [searchError, setSearchError] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [hasMoreResults, setHasMoreResults] = useState(false);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const latestQueryRef = useRef('');
    const searchResultsContainerRef = useRef(null);
    const loadMoreRef = useRef(null);
    const PAGE_SIZE = 20;
    const recipientIdSet = useMemo(()=>new Set(recipients.map((recipient)=>recipient.userId)), [
        recipients
    ]);
    const normalizeUsers = useCallback((users)=>{
        const seen = new Set();
        const filtered = [];
        users.forEach((user)=>{
            const userId = String(user.userId);
            if (recipientIdSet.has(userId) || seen.has(userId)) {
                return;
            }
            seen.add(userId);
            filtered.push({
                userId,
                userName: user.userName,
                displayName: user.displayName ?? user.userName,
                avatarUrl: user.avatarUrl ?? undefined
            });
        });
        return filtered;
    }, [
        recipientIdSet
    ]);
    const loadPage = useCallback(async (query, pageIndex)=>{
        const page = await searchUsersHandler(query.trim(), pageIndex, PAGE_SIZE);
        const users = Array.isArray(page?.content) ? page.content : [];
        return {
            users: normalizeUsers(users),
            meta: page
        };
    }, [
        normalizeUsers
    ]);
    // 사용자 검색
    const performSearch = useCallback(async (query)=>{
        if (!query.trim()) {
            setSearchResults([]);
            setSearchError(null);
            setCurrentPage(0);
            setHasMoreResults(false);
            setIsLoadingMore(false);
            latestQueryRef.current = '';
            return;
        }
        setIsSearching(true);
        setSearchError(null);
        setIsLoadingMore(false);
        latestQueryRef.current = query;
        try {
            const { users, meta } = await loadPage(query, 0);
            setSearchResults(users);
            setCurrentPage(meta?.number ?? 0);
            setHasMoreResults(!meta?.last);
        } catch (error) {
            console.error('User search failed:', error);
            // 상세한 에러 메시지 제공
            let errorMessage = '사용자 검색에 실패했습니다.';
            if (error?.response?.status === 500) {
                errorMessage = '서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.';
            } else if (error?.response?.status === 401) {
                errorMessage = '로그인이 필요합니다. 다시 로그인해주세요.';
            } else if (error?.response?.status === 403) {
                errorMessage = '접근 권한이 없습니다.';
            } else if (error?.message?.includes('timeout') || error?.code === 'ECONNABORTED') {
                errorMessage = '요청 시간이 초과되었습니다. 다시 시도해주세요.';
            } else if (error?.message?.includes('Network') || !navigator.onLine) {
                errorMessage = '네트워크 연결을 확인해주세요.';
            }
            setSearchError(errorMessage);
            setSearchResults([]);
            setHasMoreResults(false);
        } finally{
            setIsSearching(false);
        }
    }, [
        loadPage
    ]);
    const loadMore = useCallback(async ()=>{
        const query = latestQueryRef.current;
        if (!query.trim() || isLoadingMore || isSearching || !hasMoreResults) {
            return;
        }
        setIsLoadingMore(true);
        try {
            const nextPage = currentPage + 1;
            const { users, meta } = await loadPage(query, nextPage);
            setSearchResults((prev)=>{
                const map = new Map();
                prev.forEach((user)=>map.set(user.userId, user));
                users.forEach((user)=>{
                    if (!recipientIdSet.has(user.userId)) {
                        map.set(user.userId, user);
                    }
                });
                return Array.from(map.values());
            });
            setCurrentPage(meta?.number ?? nextPage);
            setHasMoreResults(!meta?.last);
        } catch (error) {
            console.error('User search load more failed:', error);
        } finally{
            setIsLoadingMore(false);
        }
    }, [
        currentPage,
        hasMoreResults,
        isLoadingMore,
        isSearching,
        loadPage,
        recipientIdSet
    ]);
    useEffect(()=>{
        if (!hasMoreResults) {
            return;
        }
        const container = searchResultsContainerRef.current;
        const sentinel = loadMoreRef.current;
        if (!container || !sentinel) {
            return;
        }
        const observer = new IntersectionObserver((entries)=>{
            const entry = entries[0];
            if (entry?.isIntersecting) {
                loadMore();
            }
        }, {
            root: container,
            rootMargin: '16px',
            threshold: 0.1
        });
        observer.observe(sentinel);
        return ()=>observer.disconnect();
    }, [
        loadMore,
        hasMoreResults
    ]);
    // 재시도 핸들러
    const handleRetrySearch = useCallback(()=>{
        if (searchTerm.trim()) {
            performSearch(searchTerm);
        }
    }, [
        searchTerm,
        performSearch
    ]);
    // 검색 디바운싱
    useEffect(()=>{
        const timeoutId = setTimeout(()=>{
            performSearch(searchTerm);
        }, 300);
        return ()=>clearTimeout(timeoutId);
    }, [
        searchTerm,
        performSearch
    ]);
    const addRecipient = (user)=>{
        setRecipients((prev)=>[
                ...prev,
                user
            ]);
        setSearchTerm('');
        setSearchResults([]);
    };
    const removeRecipient = (userId)=>{
        setRecipients((prev)=>prev.filter((r)=>r.userId !== userId));
    };
    const handleCreateChat = ()=>{
        if (recipients.length === 0) return;
        onCreateChat(recipients, groupName.trim());
    };
    const isGroupChat = recipients.length > 1;
    const canCreate = recipients.length > 0 && !isCreating;
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsx(Header, {
                children: /*#__PURE__*/ _jsxs(TitleRow, {
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            iconOnly: true,
                            icon: /*#__PURE__*/ _jsx(ArrowLeft, {
                                size: 18
                            }),
                            variant: "ghost",
                            size: "sm",
                            onClick: onBack,
                            label: "뒤로가기",
                            disabled: isCreating
                        }),
                        /*#__PURE__*/ _jsx(Title, {
                            style: {
                                flex: 1,
                                marginLeft: '0.75rem'
                            },
                            children: isGroupChat ? /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(Users, {
                                        size: 20
                                    }),
                                    "그룹 채팅 만들기"
                                ]
                            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(MessageCircle, {
                                        size: 20
                                    }),
                                    "새로운 대화"
                                ]
                            })
                        }),
                        onSwitchToAIChat && /*#__PURE__*/ _jsxs(SwitchButton, {
                            onClick: onSwitchToAIChat,
                            disabled: isCreating,
                            children: [
                                /*#__PURE__*/ _jsx(Bot, {
                                    size: 16
                                }),
                                "AI 튜터"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                style: {
                    padding: '1rem',
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column'
                },
                children: [
                    /*#__PURE__*/ _jsxs(SearchContainer, {
                        children: [
                            /*#__PURE__*/ _jsx(Search, {
                                size: 20,
                                color: "var(--theme-text-secondary, #6b7280)"
                            }),
                            /*#__PURE__*/ _jsx(SearchInput, {
                                placeholder: "받는 사람 검색 (이름 또는 사용자명)",
                                value: searchTerm,
                                onChange: (e)=>setSearchTerm(e.target.value),
                                disabled: isCreating,
                                "data-testid": CHAT_TEST_IDS.CREATE_CHAT_SEARCH_INPUT
                            }),
                            isSearching && /*#__PURE__*/ _jsx("div", {
                                style: {
                                    width: '16px',
                                    height: '16px',
                                    border: '2px solid var(--theme-border, #e5e7eb)',
                                    borderTop: '2px solid var(--theme-primary, #10b981)',
                                    borderRadius: '50%',
                                    animation: 'spin 1s linear infinite'
                                }
                            })
                        ]
                    }),
                    recipients.length > 0 && /*#__PURE__*/ _jsx("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            flexWrap: 'wrap',
                            width: '100%',
                            marginTop: '0.75rem'
                        },
                        children: recipients.map((user)=>/*#__PURE__*/ _jsx(Chip, {
                                onClose: !isCreating ? ()=>removeRecipient(user.userId) : undefined,
                                variant: "flat",
                                color: "primary",
                                size: "sm",
                                children: user.displayName || user.userName
                            }, user.userId))
                    }),
                    isGroupChat && /*#__PURE__*/ _jsx(GroupNameInput, {
                        placeholder: "그룹 이름 (선택사항)",
                        value: groupName,
                        onChange: (e)=>setGroupName(e.target.value),
                        disabled: isCreating
                    }),
                    /*#__PURE__*/ _jsxs(SearchResultsContainer, {
                        ref: searchResultsContainerRef,
                        children: [
                            isSearching && /*#__PURE__*/ _jsx(StatusMessage, {
                                type: "loading",
                                children: "사용자를 검색하고 있습니다..."
                            }),
                            searchError && /*#__PURE__*/ _jsxs(StatusMessage, {
                                type: "error",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        children: searchError
                                    }),
                                    /*#__PURE__*/ _jsx(RetryButton, {
                                        onClick: handleRetrySearch,
                                        disabled: isSearching,
                                        "data-testid": CHAT_TEST_IDS.CREATE_CHAT_SEARCH_INPUT + '-retry',
                                        children: isSearching ? '재시도 중...' : '다시 시도'
                                    })
                                ]
                            }),
                            !isSearching && !searchError && searchTerm && searchResults.length === 0 && /*#__PURE__*/ _jsxs(StatusMessage, {
                                type: "empty",
                                children: [
                                    '"',
                                    searchTerm,
                                    '"에 대한 검색 결과가 없습니다'
                                ]
                            }),
                            !isSearching && !searchError && searchResults.map((user, index)=>/*#__PURE__*/ _jsxs(UserItem, {
                                    onClick: ()=>addRecipient(user),
                                    "data-testid": `${CHAT_TEST_IDS.USER_RESULT_PREFIX}-${index}`,
                                    children: [
                                        /*#__PURE__*/ _jsx(Avatar, {
                                            src: user.avatarUrl,
                                            name: user.displayName || user.userName,
                                            size: "sm"
                                        }),
                                        /*#__PURE__*/ _jsxs(UserInfo, {
                                            children: [
                                                /*#__PURE__*/ _jsx(UserName, {
                                                    children: user.displayName || user.userName
                                                }),
                                                user.displayName && /*#__PURE__*/ _jsxs(UserUsername, {
                                                    children: [
                                                        "@",
                                                        user.userName
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, user.userId)),
                            isLoadingMore && hasMoreResults && /*#__PURE__*/ _jsx(StatusMessage, {
                                type: "loading",
                                children: "더 많은 사용자를 불러오는 중..."
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                ref: loadMoreRef
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            padding: '1rem 0',
                            borderTop: '1px solid var(--theme-border, #e5e7eb)',
                            display: 'flex',
                            justifyContent: 'flex-end'
                        },
                        children: /*#__PURE__*/ _jsxs(CreateButton, {
                            onClick: handleCreateChat,
                            disabled: !canCreate,
                            children: [
                                isGroupChat ? /*#__PURE__*/ _jsx(Users, {
                                    size: 16
                                }) : /*#__PURE__*/ _jsx(MessageCircle, {
                                    size: 16
                                }),
                                isCreating ? '생성 중...' : isGroupChat ? '그룹 만들기' : '대화 시작'
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("style", {
                children: `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `
            })
        ]
    });
};
export default CreateChatViewEnhanced;
